import React from 'react';
import styled from 'styled-components';

const PageTitle = styled.span`
    display: block;
    font-family: 'PT Sans Narrow', sans-serif !important;
    text-transform: uppercase;
    width: 100%;
    text-align: center;
    font-size: 36px;
    font-weight: 700;
    color: ${({ theme }) => theme.color.scDarkGray3};
    text-shadow: 0px 1px 0px rgba(255,255,255,.75);
    margin: ${({ theme }) => theme.margin.med} auto;
    margin-top: ${({ theme }) => theme.margin.xlrg};

    @media(max-width: ${({ theme }) => theme.width.phone}) {
        font-size: 28px;
    }
`;
export default PageTitle;


// WEBPACK FOOTER //
// ./src/sc-ui/PageTitle.jsx